let infoName = "userInfo"
export function getToken(){
    let info = localStorage.getItem("token")
    if(info){
        return info
    }
   return null
}
export function setInfo(userInfo){
    localStorage.setItem(infoName,JSON.stringify(userInfo))
    localStorage.setItem("token",userInfo.token)
}
export function getInfo(){
    return JSON.parse(localStorage.getItem(infoName))
}
export function loginout(){
    localStorage.removeItem(infoName)
    localStorage.removeItem('token')
}
export function setObj(key,value){
    localStorage.setItem(key,JSON.stringify(value))
}
export function getObj(key){
    return JSON.parse(localStorage.getItem(key))
}


// WEBPACK FOOTER //
// ./src/utils/auth.js